var generateStyle = function generateStyle(componentTheme) {
  return {
    contentWrapper: {
      minHeight: '10rem',
      padding: componentTheme.contentWrapperPadding,
      border: "".concat(componentTheme.contentWrapperBorderSize, " solid ").concat(componentTheme.contentWrapperBorderColor),
      borderRadius: componentTheme.contentWrapperBorderRadius
    }
  };
};
export default generateStyle;